module.exports = __webpack_public_path__ + "img/logo1.0c7b23ae.png";